export const calculatePercentOffMsrp = ({
  totalMsrpInCents,
  totalPriceInCents,
}: {
  totalMsrpInCents: number;
  totalPriceInCents: number;
}): number => {
  return +((1 - totalPriceInCents / totalMsrpInCents) * 100).toFixed(2);
};

export const getAboveBelowMsrpFullText = (percentOffMsrp: number): string => {
  return `${Math.abs(percentOffMsrp)}% ${getAboveBelowMsrpTextOnly(percentOffMsrp)}`;
};

export const getAboveBelowMsrpTextOnly = (percentOffMsrp: number): string => {
  return percentOffMsrp < 0 ? 'Above MSRP' : 'Off MSRP';
};
